const ImageWithCaption = ({ src, alt, caption, shadow = '' }) => (
  <div className='flex flex-col h-full'>
    <figure className='mb-2'>
      <img src={src} alt={alt} className={`w-full h-full ${shadow}`} />
    </figure>
    <p className='text-center text-neutral-7'>{caption}</p>
  </div>
);

export default ImageWithCaption;
